import { useSearchParams } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import ErrorIcon from "@mui/icons-material/Error";
import Button from "@mui/material/Button";

const AuthError = () => {
  const auth = useAuth();
  const [searchParams] = useSearchParams();

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          border: "1px solid red",
          borderRadius: 8,
          backgroundColor: "white",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            borderBottom: "2px solid red",
            // marginBottom: 5,
            padding: 10,
            fontWeight: 600,
            fontSize: 18,
            color: "red",
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <ErrorIcon />
          Uhoh, something went wrong
        </div>
        {/* BODY */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 12,
            padding: 10,
          }}
        >
          <div>{searchParams.get("error_description")}</div>
        </div>
      </div>

      <Button
        id="authLogoutButton"
        color="primary"
        variant="contained"
        onClick={() => {
          auth.signoutRedirect();
          auth.clearStaleState();
        }}
      >
        Logout of KochID
      </Button>
    </div>
  );
};

export default AuthError;
